// removed by extract-text-webpack-plugin
module.exports = {"partyMember":"client-components-Party-styles__partyMember___1UPBV","avatar":"client-components-Party-styles__avatar___2DJtL","bio":"client-components-Party-styles__bio___2yMVS","party":"client-components-Party-styles__party___2AzbN","parties":"client-components-Party-styles__parties___mepo_","name":"client-components-Party-styles__name___1d63T","role":"client-components-Party-styles__role___6pKhW","content":"client-components-Party-styles__content___4f7BA"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Party/styles.css
// module id = 398
// module chunks = 0